module.exports = __webpack_public_path__ + "media/images/icons/info_icon-04a5d0e8990633dad6622c401bbbe9ce.svg";